<template>
  <a-drawer width="45%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>Detail</b>
    </a-divider>
    <a-form-model ref="form" layout="vertical" :model="form">

      <a-form-model-item prop="auditStatus" label="Status">
        <span v-if="form.auditStatus === 0"> {{ $t('待审核') }}</span>
        <span v-if="form.auditStatus === 1">{{ $t('已通过') }}</span>
        <span v-if="form.auditStatus === 2">{{ $t('已拒绝') }}</span>
      </a-form-model-item>
      <a-form-model-item v-if="form.auditStatus === 2" prop="submitContent" label="Reason">
        <span>{{ form.auditRemark }}</span>
      </a-form-model-item>

      <template v-for="(order,index) in orderList">
        <a-form-model-item :key="order.id" style="border: 1px solid #efefef; border-radius: 4px; padding: 10px 5px;" :label="`Order${index+1}: ${order.orderNo}`">
          <div v-if="order.proofImages && order.proofImages.length > 0" class="order-image-view">
            <img v-for="(src,imgIndex) in order.proofImages" :key="imgIndex" class="order-image" :src="src" alt="" />
          </div>
        </a-form-model-item>
      </template>
      <div class="bottom-control">
        <a-space>
          <a-button v-if="form.auditStatus === 0" type="primary" :loading="submitLoading" @click="handlePass">
            {{ $t('审核通过') }}
          </a-button>
          <a-button v-if="form.auditStatus === 0" type="danger" :loading="submitLoading" @click="handleShowReject">
            {{ $t('审核拒绝') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>

    <reject-modal
      :visible="rejectModalVisible"
      :onReject="handleBatchReject"
      @cancel="rejectModalVisible = false"
    />
  </a-drawer>
</template>

<script>
import { getTaskSubmit, batchPassTaskSubmit, batchRejectTaskSubmit } from '@/api/task/taskSubmit'
import { mapGetters } from 'vuex'
import CustomDictTag from '@/components/DictCustomTag'

import Editor from '@/components/Editor'
import RejectModal from '@/components/RejectModal/index.vue'
import { listTaskSubmitOrder } from '@/api/task/taskSubmitOrder'

export default {
  name: 'DetailView',
  props: {},
  components: {
    RejectModal,
    CustomDictTag,
    Editor
  },
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,

        taskId: null,

        userId: null,

        userName: null,

        submitContent: null,

        rewardPoints: null,

        submitTime: null,

        auditStatus: 0,

        auditRemark: null,

        auditor: null,

        auditTime: null

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        taskId: [
          { required: true, message: '任务ID' + this.$t('不能为空'), trigger: 'blur' }
        ],
        userId: [
          { required: true, message: '用户ID' + this.$t('不能为空'), trigger: 'blur' }
        ],
        submitTime: [
          { required: true, message: '提交时间' + this.$t('不能为空'), trigger: 'blur' }
        ],
        auditStatus: [
          { required: true, message: '审核状态 0=待审核 1=审核通过 2=审核拒绝' + this.$t('不能为空'), trigger: 'blur' }
        ]
      },
      rejectModalVisible: false,
      orderList: []
    }
  },
  filters: {},
  created() {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  mounted() {
  },
  methods: {
    onClose() {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        taskId: null,
        userId: null,
        userName: null,
        submitContent: null,
        rewardPoints: null,
        submitTime: null,
        auditStatus: 0,
        auditRemark: null,
        auditor: null,
        auditTime: null
      }
    },
    handleShow(row) {
      this.reset()
      const id = row.id
      this.getInfo(id)
    },
    getInfo(id) {
      getTaskSubmit({ 'id': id }).then(response => {
        this.form = response.data
        this.open = true
      })
      listTaskSubmitOrder({ 'submitId': id }).then(response => {
        this.orderList = response.data
      })
    },
    async handlePass() {
      this.submitLoading = true
      await batchPassTaskSubmit([this.form.id])
      this.getInfo(this.form.id)
      this.submitLoading = false
      const message = this.$t('审核成功')
      this.$message.success(
        message,
        3
      )
      this.cancel()
      this.$emit('ok')
    },
    handleShowReject() {
      this.rejectModalVisible = true
    },
    handleBatchReject(reason) {
      const data = [this.form.id]
      return batchRejectTaskSubmit({ ids: data, reason: reason })
        .then(() => {
          const id = this.form.id
          this.getInfo(id)
          const message = this.$t('拒绝成功')
          this.$message.success(
            message,
            3
          )
          this.rejectId = undefined
          this.rejectModalVisible = false
          this.$emit('ok')
        }).catch(() => {
          this.rejectId = undefined
          this.rejectModalVisible = false
        })
    }
  }
}
</script>

<style lang="less" scoped>
.order-image-view {
  width: 100%;
  height: 150px;
  display: flex;
  flex-direction: row;
  gap: 10px;
  flex-wrap: nowrap;
  overflow-x: auto;

  .order-image {
    width: 150px;
    height: 150px;
    border-radius: 8px;
  }
}

</style>
